export default "__VITE_ASSET__DHhw5O6T__"